<template>
  <v-container fluid>
    <alert-error :error="error"></alert-error>
    <v-toolbar>
      <v-toolbar-title>{{ $t('NAVIGATION.BOOKING_SCHEDULE') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="indigo"
        :dark="selectedResource"
        :disabled="!selectedResource"
        @click="createReservation"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('BOOKING.RESERVATIONS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <booking-schedule-filter @setRequest="setRequest" />

      <booking-schedule
        v-if="selectedResource"
        :booking-schedule="bookingSchedule"
        :options="options"
        @show="viewReservation"
        @refresh="refreshData"
      ></booking-schedule>

      <blockers
        v-if="selectedResource"
        :resource="resource"
        @createBlock="createBlock"
      />
    </v-sheet>

    <v-dialog
      v-model="dialog"
      persistent
      :max-width="action === 'create-capacity' ? '1510px' : '800px'"
    >
      <template v-if="action">
        <component
          :is="component"
          v-if="selectedResource"
          :id="reservationId"
          :key="component"
          :block-type="data.type"
          :resource-id="options.resource"
          :resource="resource"
          @created="cancelDialogAndRefresh"
          @updated="cancelDialogAndRefresh"
          @cancel="cancelDialog"
        ></component>
      </template>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BookingSchedule from '@/modules/booking_schedule/components/BookingSchedule';
import BookingScheduleFilter from '@/modules/booking_schedule/components/forms/BookingScheduleFilter';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import isIndividual from '@/modules/booking_schedule/mixins/isIndividual';
import Blockers from '@/modules/booking_schedule/components/Blockers.vue';
import { BLOCK } from '@/modules/booking_schedule/common/types';

export default {
  name: 'BookingResourcesPage',

  components: {
    Blockers,
    BookingSchedule,
    BookingScheduleFilter,
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    CreateReservation: () =>
      import(
        '@/modules/booking_reservations/components/Reservation/CreateReservation.vue'
      ),
    CreateBlockReservation: () =>
      import('@/modules/booking_blocks/components/Reservation/CreateBlock.vue'),
    CreateCapacityReservation: () =>
      import(
        '@/modules/booking_reservations/components/Reservation/CreateCapacityReservation.vue'
      ),
    ViewReservation: () =>
      import(
        '@/modules/booking_reservations/components/Reservation/ViewReservation.vue'
      ),
    ViewBlockReservation: () =>
      import('@/modules/booking_blocks/components/Reservation/ViewBlock.vue')
  },

  mixins: [i18nRefreshData, isIndividual],

  data() {
    return {
      dialog: false,
      error: null,
      action: null,
      reservationId: null,
      options: {},
      resource: null,
      params: {},
      blockDialog: {},
      data: { type: {} }
    };
  },

  computed: {
    ...mapState('booking_schedule', ['bookingSchedule']),

    selectedResource() {
      return Boolean(this.options.resource);
    },

    component() {
      return `${this.action}-reservation`;
    }
  },

  methods: {
    ...mapActions('booking_schedule', ['getBookingSchedule']),
    ...mapActions('booking_resources', ['getBookingResource']),
    getDataBookingResources(params) {
      this.getBookingSchedule(params).catch(error => {
        this.error = error;
      });
    },
    setRequest(v) {
      this.options = v;
    },
    createBlock(type) {
      this.data.type = type;
      this.dialog = true;
      this.action = 'create-block';
      this.showDialog();
    },
    createReservation() {
      this.dialog = true;

      if (this.resource.type_id === 1 || this.isIndividual) {
        this.action = 'create';
      } else {
        this.action = 'create-capacity';
      }
      this.showDialog();
    },
    viewReservation(reservation) {
      this.action = reservation.type === BLOCK ? 'view-block' : 'view';
      this.reservationId = reservation.id;
      this.showDialog();
    },
    showDialog() {
      this.dialog = true;
    },
    cancelDialog() {
      this.dialog = false;
      this.action = null;
      this.reservationId = null;
    },
    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.options = { ...this.options }; // refresh
    },

    getResource(id) {
      this.getBookingResource({ resourceId: id }).then(({ data }) => {
        this.resource = data;
      });
    },

    refreshData(params = this.params) {
      this.params = params;
      this.getDataBookingResources(params);
      this.getResource(params.id);
    }
  }
};
</script>
